<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center">
      <div>
       <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <h1>Anmelden</h1>
    </b-row>
    <b-row class="m-0 mt-4 justify-content-center">
      
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 v-if="!contactFormSent" class="text-center">Du hast bereits ein Konto? </h4>

        <p class="text-center m-0 mt-3">Logge dich mit deiner E-Mail-Adresse und deinem Passwort ein:</p>

      <b-form class="mt-5" @submit.prevent="submitForm()">

        <b-form-group
        label="Deine E-Mail-Adresse:"
        >
          <b-form-input
            :state="form.email && !authError? true : false"
            v-model="form.email"
            id="email"
            type="email"
            required
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ authMessage }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Dein Passwort:"
        >
          <b-form-input
            id="password"
            :state="form.password && !authError? true : false"
            v-model="form.password"
            type="password"
            required
          ></b-form-input>
           <b-form-invalid-feedback>
            {{ authMessage }}
          </b-form-invalid-feedback>
        </b-form-group>

        <p class="text-center custom-nav m-0 my-3" @click="$router.push('/passwordforgot').catch(err => {})">Passwort vergessen?</p>
        
        <b-button type="submit" style="width: 100%" size="md" variant="dark">Anmelden</b-button>

        <p class="text-center m-0 mb-3 mt-5" >Neu hier?</p>
        
        <b-button style="width: 100%" size="md" variant="dark" @click="$router.push('/register').catch(err => {})">Jetzt Konto anlegen</b-button>

      </b-form>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Login',
  mixins: [coreData],
  data: () => {
    return {
      form: {},
    }
  },
  components: {
    Footer
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    }
  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    } 
  }
}
</script>